<div class="customer-info-container" *ngIf="customer$ | async as customer">
  <h3 class="customer-info-title">Customer Info</h3>
  <div class="customer-details">
    <p class="customer-name">{{ getCustomerFullName(customer?.data) }}</p>
    <div class="contact-info">
      <div class="info-item">
        <span class="info-label">PHONE NUMBER</span>
        <span class="info-value">{{ customer?.data?.contact }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">EMAIL</span>
        <span class="info-value">{{ customer?.data?.email }}</span>
      </div>
    </div>
  </div>
</div>
